import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I'm a software engineer with a strong focus on <b className="purple">AI, machine learning, and full-stack development.</b> Over the years, I've built scalable systems, intelligent services, and robust cloud infrastructure at companies like <b className="purple">Microsoft</b> and <b className="purple">Unified Patents</b>.
            <br />
            <br />
            My technical toolkit includes <b className="purple">Python, JavaScript, C#</b>, and a mix of modern frameworks like <b className="purple">React, Node.js, and .NET</b>. I'm especially interested in how emerging technologies like <b className="purple">blockchain</b> and <b className="purple">AI</b> can intersect to solve real-world problems.
            <br />
            <br />
            Outside of work, I collect and trade TCGs (yes, those shiny little cardboards), and I've been known to perform magic tricks — though I promise I don't use sleight of hand in my code. 🪄
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

      </Container>
    </Container>
  );
}
export default Home2;
